import { render, staticRenderFns } from "./CopySummaryCollapses.vue?vue&type=template&id=1754deb1&scoped=true"
import script from "./CopySummaryCollapses.vue?vue&type=script&lang=js"
export * from "./CopySummaryCollapses.vue?vue&type=script&lang=js"
import style0 from "./CopySummaryCollapses.vue?vue&type=style&index=0&id=1754deb1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1754deb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1754deb1')) {
      api.createRecord('1754deb1', component.options)
    } else {
      api.reload('1754deb1', component.options)
    }
    module.hot.accept("./CopySummaryCollapses.vue?vue&type=template&id=1754deb1&scoped=true", function () {
      api.rerender('1754deb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/components/configurationCopy/modais/CopySummaryCollapses.vue"
export default component.exports